(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
      this.header.querySelectorAll(".academy-plus details[open]").forEach(details => {
        details.removeAttribute("open");
        const summary = details.querySelector("summary");
        if (summary) summary.setAttribute("aria-expanded", "false");
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magazine-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tt-magazine-library-v3')) {
    customElements.define('tt-magazine-library-v3', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.panels = [...this.querySelectorAll('[data-issue]')];
        const months = ['january','february','march','april','may','june','july','august','september','october','november','december'];
        const dateValue = panel => {
          const match = (panel.dataset.monthYear || '').toLowerCase().match(/^([a-z]+)\s+(\d{4})$/);
          const month = match ? months.indexOf(match[1]) : -1;
          return match && month >= 0 ? Number(match[2]) * 12 + month : -1;
        };
        const byNumber = new Map();
        for (const panel of this.panels) {
          const number = Number(panel.dataset.issue);
          const existing = byNumber.get(number);
          if (!existing || dateValue(panel) > dateValue(existing)) byNumber.set(number, panel);
        }
        this.issues = [...byNumber.entries()].sort((a,b) => a[0] - b[0]);
        if (!this.issues.length) {
          this.querySelector('[data-empty]').hidden = false;
          return;
        }
        this.published = this.issues.filter(([, panel]) => !panel.dataset.comingSoon);
        const exploreIssue = this.published.find(([number]) => number > 1);
        this.querySelectorAll('[data-explore]').forEach(button => {
          button.hidden = !exploreIssue;
          if (exploreIssue) {
            button.dataset.exploreIssue = exploreIssue[0];
            button.querySelector('[data-explore-label]').textContent = `Explore more magazines → ${exploreIssue[1].querySelector('h2').textContent}`;
          }
        });
        this.years = [...new Set(this.issues.map(([number]) => Math.ceil(number / 12)))];
        this.querySelectorAll('[data-navigation]').forEach(control => { control.hidden = false; });
        this.addEventListener('click', event => {
          const control = event.target.closest('button,a');
          if (!control || !this.contains(control)) return;
          if (control.matches('[data-explore]')) this.select(Number(control.dataset.exploreIssue), true);
          if (control.matches('[data-number]')) this.select(Number(control.dataset.number), true);
          if (control.matches('[data-issue-step]')) {
            const issue = this.adjacentPublished(Number(control.dataset.issueStep));
            if (issue) this.select(issue[0], true);
          }
          if (control.matches('[data-year-step]')) {
            const index = this.years.indexOf(Math.ceil(this.selected / 12));
            const next = index + Number(control.dataset.yearStep);
            const year = this.years[this.dataset.wrap === 'true' ? (next + this.years.length) % this.years.length : next];
            const issue = this.issues.find(([number]) => Math.ceil(number / 12) === year);
            if (issue) this.select(issue[0], true);
          }
          if (control.matches('[data-reader]')) {
            const dialog = this.querySelector('[data-reader-dialog]');
            if (!dialog || typeof dialog.showModal !== 'function') return;
            event.preventDefault();
            this.readerTrigger = control;
            this.readerSources = { pages:control.dataset.pages, spreads:control.dataset.spreads };
            this.querySelector('[data-reader-title]').textContent = control.closest('[data-issue]').querySelector('h2').textContent;
            this.querySelectorAll('[data-view]').forEach(button => { button.hidden = !this.readerSources[button.dataset.view]; });
            this.setReaderView(this.readerSources.pages ? 'pages' : 'spreads');
            dialog.showModal();
          }
          if (control.matches('[data-view]')) this.setReaderView(control.dataset.view);
          if (control.matches('[data-reader-close]')) this.querySelector('[data-reader-dialog]').close();
        }, { signal });
        this.querySelector('[data-reader-dialog]')?.addEventListener('close', () => {
          this.querySelector('[data-reader-frame]').removeAttribute('src');
          this.readerTrigger?.focus();
        }, { signal });
        const latest = this.published.reduce((best, issue) => dateValue(issue[1]) > dateValue(best[1]) ? issue : best);
        const requested = Number(this.dataset.initial);
        const initial = this.dataset.start === 'issue' && byNumber.has(requested) ? requested : latest[0];
        const linkedValue = new URLSearchParams(window.location.search).get('issue') || '';
        const linkedNumber = /^\d{1,2}$/.test(linkedValue) ? Number(linkedValue) : NaN;
        const hasLinkedIssue = byNumber.has(linkedNumber);
        this.select(hasLinkedIssue ? linkedNumber : initial);
        if (hasLinkedIssue) {
          requestAnimationFrame(() => {
            if (this.isConnected) byNumber.get(linkedNumber).scrollIntoView({ behavior:'auto', block:'start' });
          });
        }
      }
      adjacentPublished(direction) {
        const ordered = direction > 0 ? this.published : [...this.published].reverse();
        const issue = ordered.find(([number]) => direction > 0 ? number > this.selected : number < this.selected)
          || (this.dataset.wrap === 'true' ? ordered[0] : undefined);
        return issue?.[0] === this.selected ? undefined : issue;
      }
      select(number, focus = false) {
        this.selected = number;
        const selected = this.issues.find(([value]) => value === number)[1];
        this.panels.forEach(panel => { panel.hidden = panel !== selected; });
        const year = Math.ceil(number / 12);
        this.querySelector('[data-year-name]').textContent = `Year ${year}`;
        const list = this.querySelector('[data-issue-list]');
        list.replaceChildren();
        for (let issue = (year - 1) * 12 + 1; issue <= year * 12; issue++) {
          const entry = this.issues.find(([value]) => value === issue);
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = String(issue);
          button.dataset.number = issue;
          button.disabled = !entry;
          if (entry?.[1].dataset.comingSoon) {
            button.dataset.comingSoon = 'true';
            button.title = `Coming Soon — ${entry[1].dataset.monthYear}`;
            const label = document.createElement('span');
            label.className = 'ttml__soon-label';
            label.textContent = 'Coming Soon';
            label.setAttribute('aria-hidden','true');
            button.append(label);
          }
          button.setAttribute('aria-label', entry ? `${entry[1].querySelector('h2').textContent}${entry[1].dataset.comingSoon ? ` — ${entry[1].dataset.monthYear}` : ''}` : `Issue ${issue}: not available yet`);
          if (issue === number) button.setAttribute('aria-current','true');
          list.append(button);
        }
        const wrap = this.dataset.wrap === 'true';
        this.querySelector('[data-issue-step="-1"]').disabled = !this.adjacentPublished(-1);
        this.querySelector('[data-issue-step="1"]').disabled = !this.adjacentPublished(1);
        const yearIndex = this.years.indexOf(year);
        this.querySelector('[data-year-step="-1"]').disabled = this.years.length < 2 || (!wrap && yearIndex === 0);
        this.querySelector('[data-year-step="1"]').disabled = this.years.length < 2 || (!wrap && yearIndex === this.years.length - 1);
        this.querySelector('[data-announcement]').textContent = selected.querySelector('h2').textContent;
        if (focus) {
          const url = new URL(window.location.href);
          url.searchParams.set('issue',String(number));
          window.history.replaceState(window.history.state,'',url);
          selected.querySelector('h2').focus({ preventScroll:true });
        }
      }
      setReaderView(view) {
        const url = this.readerSources?.[view];
        if (!url) return;
        this.querySelector('[data-reader-frame]').src = url;
        this.querySelector('[data-reader-open]').href = url;
        this.querySelectorAll('[data-view]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.view === view)));
      }
      disconnectedCallback() {
        this.querySelector('[data-reader-dialog]')?.close();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
